import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { generateApiPath } from 'src/utils';
import ModalDialog, {
  isModalComplete,
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useForm, FormField } from 'src/components/Form';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useStoreUnitActions } from 'src/redux/helpers';
import solutionsStore from '../../redux';
import { createDashboardFormFields } from '../formFields';
import { API_ASSET_DASHBOARD_CREATE } from '../../constants';

type Props = {
  api: string;
  formFields: FormField[];
  title: string;
  open: boolean;
  onClose: ModalCloseHandler;
  id?: string;
  siteIds?: any;
  level: number;
  sitesId?: string;
  setLoader: any;
};

function SolutionDashboardCreateModal({
  id,
  siteIds,
  level,
  open,
  setLoader,
  sitesId,
  onClose,
}: Props) {
  const actions = useStoreUnitActions(solutionsStore);
  const { showAlert } = useAlert();
  const { solutionId } = useParams();

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generateApiPath(API_ASSET_DASHBOARD_CREATE, {
          solutionId,
          twinId: id,
        }),
        params,
      }),
    (res, params) => {
      showAlert({
        type: AlertType.Success,
        title: 'Dashboard created',
        text: `${params.name} dashboard created successfully`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.dashboardList({ solutionId, twinId: id });
    }
  );

  const [formComponent, handleSubmit] = useForm({
    fields: createDashboardFormFields,
    onSubmit,
  });

  return (
    <>
      <ModalDialog
        title="Create Dashboard"
        open={open}
        loading={loading}
        onClose={onClose}
        onConfirm={handleSubmit}
        confirmBtnText="Save"
        maxWidth="sm"
        fullWidth
      >
        {formComponent}
      </ModalDialog>
    </>
  );
}

export default SolutionDashboardCreateModal;
